"use client";

import Script from "next/script";
import { thirdPartyScriptCrossOriginProp } from "@/lib/analytics/third-party-scripts";

const SENDPULSE_WIDGET_ID = process.env.NEXT_PUBLIC_SENDPULSE_WIDGET_ID?.trim();
const SENDPULSE_ENABLED =
  process.env.NEXT_PUBLIC_ENABLE_SENDPULSE === "true" ||
  process.env.NODE_ENV === "production";

export default function SendpulseWidget() {
  if (!SENDPULSE_ENABLED || !SENDPULSE_WIDGET_ID) {
    return null;
  }

  return (
    <Script
      id="sendpulse-popups-loader"
      src="https://static.sppopups.com/assets/loader.js"
      strategy="afterInteractive"
      crossOrigin={thirdPartyScriptCrossOriginProp("sendpulse")}
      data-chats-widget-id={SENDPULSE_WIDGET_ID}
    />
  );
}
